import React from "react";
import { Link } from "react-router-dom";
import { nameToSlug } from "../utils/affiliateHelper";

/**
 * Renders artist name(s) as clickable links.
 * Uses release.artists_parsed if available, falls back to release.interpret.
 */
export default function ArtistLinks({ release, className = "", stopPropagation = false }) {
  const artists =
    release.artists_parsed?.length > 0
      ? release.artists_parsed
      : [release.interpret].filter(Boolean);

  return (
    <span className={className}>
      {artists.map((name, i) => (
        <React.Fragment key={name + i}>
          <Link
            to={`/artist/${nameToSlug(name)}`}
            onClick={stopPropagation ? (e) => e.stopPropagation() : undefined}
            className="hover:text-rose-300 transition-colors"
          >
            {name}
          </Link>
          {i < artists.length - 1 && (
            <span className="text-zinc-500 font-normal"> &amp; </span>
          )}
        </React.Fragment>
      ))}
    </span>
  );
}
